import { Component, Input } from '@angular/core';

@Component({
    selector: 'pr-panel-footer',
    templateUrl: './pr-panel-footer.component.html',
    styleUrls: ['./pr-panel-footer.component.scss'],
    standalone: false
})
export class PrPanelFooterComponent {
  @Input() clazz: string;

  constructor() {}
}
